/* ==========================================================================
   FTB · photo guard
   Added 2026-08-21, in place of the photolock app.

   WHAT THIS DOES
   Blocks the right-click menu and drag-to-save on the PRODUCT PAGE GALLERY
   only, and suppresses the iOS long-press "Save Image" sheet on the same
   images. Nothing else on the site is touched.

   WHAT THIS DOES NOT DO, AND CANNOT
   It does not protect the images. By the time a visitor sees a photo their
   browser has already downloaded it. This is defeated by DevTools, by turning
   JavaScript off, by any screenshot, and by requesting the cdn.shopify.com URL
   directly, which Shopify serves publicly at any size you ask for. It is a
   speed bump against casual right-click-and-save. Treat it as nothing more.
   The real protection already in place is resolution: every product master is
   capped at 2048px, which prints about 6.8 inches at 300dpi.

   >>> DO NOT WIDEN THE SCOPE. <<<
   MEASURED on the draft theme, 2026-08-21:
     product page   .product__photo img   10 images,  0 inside a link
     collection grid    every card image  371 of 373 INSIDE a product link
   On a collection page the image IS the link, so right-clicking a card is
   exactly how a customer opens a product in a new tab. Blocking there would
   break the behaviour the owner explicitly asked to keep. The gallery is safe
   precisely because none of its images are links.
   ========================================================================== */
(function () {
  'use strict';

  var SCOPE = '.product__photo';

  /* The iOS long-press sheet and the drag ghost are CSS, not events, so they
     need their own rules. Injected rather than living in a stylesheet so the
     whole guard stays in one file and travels together. */
  try {
    var s = document.createElement('style');
    s.setAttribute('data-ftb-photo-guard', '');
    s.textContent =
      '.product__photo img{-webkit-touch-callout:none;-webkit-user-drag:none;' +
      'user-select:none;-webkit-user-select:none;}';
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}

  function guarded(node) {
    if (!node || !node.closest) return false;
    if (!node.closest(SCOPE)) return false;
    /* Belt and braces. If a gallery image is ever wrapped in a link by a future
       theme change, stand down so "Open link in new tab" keeps working. */
    if (node.closest('a')) return false;
    return true;
  }

  document.addEventListener('contextmenu', function (e) {
    if (guarded(e.target)) e.preventDefault();
  }, false);

  document.addEventListener('dragstart', function (e) {
    if (guarded(e.target)) e.preventDefault();
  }, false);
})();
